module.exports = __webpack_public_path__ + "static/media/dairy-diet-eating-svgrepo-com.cdefef25.svg";